/**
 * custom-javascript.js
 * Domino Vacanze — JS tema generale
 *
 * Posizione: src/js/custom-javascript.js
 * Compila in: js/theme.js (Understrap build)
 *
 * Contenuto:
 *   1. Navbar — scroll class toggle (transparent → scrolled) + logo swap
 *   2. Offcanvas — blocca scroll body quando aperto
 *   3. IntersectionObserver — fade-up on scroll
 *   4. Lucide Icons — init
 */

( function () {

    'use strict';

    // =========================================================================
    // 1. NAVBAR SCROLL + LOGO SWAP
    // =========================================================================
    const navbar        = document.querySelector( '.navbar' );
    const navbarWrapper = document.getElementById( 'wrapper-navbar' );
    const pageWrapper   = document.getElementById( 'page-wrapper' );
    const logoLight     = navbar ? navbar.querySelector( '.navbar-logo--light' ) : null;
    const logoDark      = navbar ? navbar.querySelector( '.navbar-logo--dark' )  : null;

    if ( navbar ) {

        const SCROLL_THRESHOLD = 60;
        const isInnerPage      = document.body.classList.contains( 'is-inner-page' );

        // ── Helpers ───────────────────────────────────────────────────────
        function showLightLogo() {
            if ( logoLight ) logoLight.style.display = 'block';
            if ( logoDark  ) logoDark.style.display  = 'none';
        }

        function showDarkLogo() {
            if ( logoLight ) logoLight.style.display = 'none';
            if ( logoDark  ) logoDark.style.display  = 'block';
        }

        function setNavbarSolid() {
            navbar.classList.add( 'navbar--scrolled' );
            navbar.classList.remove( 'navbar--transparent' );
            showDarkLogo();
        }

        function setNavbarTransparent() {
            navbar.classList.remove( 'navbar--scrolled' );
            navbar.classList.add( 'navbar--transparent' );
            showLightLogo();
        }

        function setPageOffset() {
            if ( navbarWrapper && pageWrapper ) {
                pageWrapper.style.paddingTop = navbarWrapper.offsetHeight + 'px';
            }
        }

        function updateNavbarOnScroll() {
            if ( window.scrollY > SCROLL_THRESHOLD ) {
                setNavbarSolid();
            } else {
                setNavbarTransparent();
            }
        }

        // ── Pagine interne → sempre solid ─────────────────────────────────
        if ( isInnerPage ) {
            setNavbarSolid();
            setPageOffset();
            window.addEventListener( 'scroll', setNavbarSolid, { passive: true } );
            window.addEventListener( 'resize', setPageOffset,  { passive: true } );

        // ── Homepage → trasparente con transizione allo scroll ─────────────
        } else {
            setNavbarTransparent(); // stato iniziale
            updateNavbarOnScroll(); // check se già scrollata al caricamento
            window.addEventListener( 'scroll', updateNavbarOnScroll, { passive: true } );
        }

    }


    // =========================================================================
    // 2. OFFCANVAS — lock/unlock body scroll
    // Quando l'offcanvas è aperto il body non deve scrollare.
    // Bootstrap 5 lo gestisce nativamente via data-bs-scroll="false",
    // ma aggiungiamo anche la classe .offcanvas-is-open sul body
    // per eventuali override CSS specifici.
    // =========================================================================
    const offcanvasEl = document.getElementById( 'navMenuOffcanvas' );

    if ( offcanvasEl && typeof bootstrap !== 'undefined' && bootstrap.Offcanvas ) {

        offcanvasEl.addEventListener( 'show.bs.offcanvas', function () {
            document.body.classList.add( 'offcanvas-is-open' );
        } );

        offcanvasEl.addEventListener( 'hidden.bs.offcanvas', function () {
            document.body.classList.remove( 'offcanvas-is-open' );
        } );
    }


    // =========================================================================
    // 3. FADE-UP ON SCROLL — IntersectionObserver
    // =========================================================================
    const fadeElements = document.querySelectorAll( '.fade-up' );

    if ( fadeElements.length > 0 ) {

        if ( ! ( 'IntersectionObserver' in window ) ) {
            fadeElements.forEach( function ( el ) { el.classList.add( 'is-visible' ); } );
        } else {

            const fadeObserver = new IntersectionObserver(
                function ( entries ) {
                    entries.forEach( function ( entry ) {
                        if ( entry.isIntersecting ) {
                            entry.target.classList.add( 'is-visible' );
                            fadeObserver.unobserve( entry.target );
                        }
                    } );
                },
                {
                    threshold:  0.12,
                    rootMargin: '0px 0px -40px 0px',
                }
            );

            fadeElements.forEach( function ( el ) { fadeObserver.observe( el ); } );
        }
    }


    // =========================================================================
    // 4. LUCIDE ICONS
    // =========================================================================
    if ( typeof lucide !== 'undefined' ) {
        lucide.createIcons();
    }

} )();